import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminSupport, getFullChat } from '../../store/chat/chatActions';
import { getImage } from '../../utils';
import NotFoundWidget from '../widgets/NotFound';
import { SocketContext } from '../../utils/socketConfig';
import Search from './seach-input';
import { FiHeadphones } from 'react-icons/fi';

function chatListFileLabel(message) {
    if (!message?.isFile) return null;
    const raw =
        message.file?.originalName ||
        message.file?.originalname ||
        message.file?.name;
    if (typeof raw === 'string' && raw.trim()) return raw.trim();
    return 'File';
}

function chatListPreviewText(message) {
    if (!message) return '';
    if (message.hidden === true) return 'Deleted message';
    if (message.isFile) return chatListFileLabel(message) ?? 'File';
    return message.message ?? '';
}

const Messages = ({ getMessage = false, search = true, defaultChat = null }) => {

    const dispatch = useDispatch();
    const { currentChat, chats } = useSelector((state) => state.chat)
    const [searchText, setSearchText] = useState("")
    const socket = useContext(SocketContext);

    useEffect(() => {
        if (getMessage) {
            dispatch(getAdminSupport())
        }
    }, [getMessage, dispatch])

    useEffect(() => {
        if (socket == null) return undefined;
        const handler = () => {
            dispatch(getAdminSupport());
        };
        socket.on("message", handler);
        return () => {
            socket.off("message", handler);
        };
    }, [socket, dispatch]);

    useEffect(() => {
        if (defaultChat) {
            handleReadMessage(defaultChat)
        }

    }, [defaultChat])

    const handleReadMessage = (id, perspectiveProfileId) => {
        if (perspectiveProfileId != null && String(perspectiveProfileId).length > 0) {
            dispatch(getFullChat({ id, perspectiveProfileId: String(perspectiveProfileId) }));
        } else {
            dispatch(getFullChat({ id }));
        }
    }

    const handleChangeSearchText = (value) => {
        setSearchText(value)
    }

    const MessagesItem = ({ chat }) => {
        const isSelected = (currentChat !== null ? chat._id === currentChat._id : false);
        const raw = typeof chat.unreadCount === 'number' ? chat.unreadCount : 0;
        const n = isSelected ? 0 : raw;

        const perspectiveId =
            chat.viewerProfileId != null && String(chat.viewerProfileId).length > 0
                ? String(chat.viewerProfileId)
                : chat.profile != null && String(chat.profile).length > 0
                    ? String(chat.profile)
                    : undefined;
        const preview = chatListPreviewText(chat.message);
        const deletedLast = Boolean(chat.message?.hidden);

        return (
                <div onClick={() => (!isSelected && !getMessage) && handleReadMessage(chat._id, perspectiveId)} className={`group relative flex cursor-pointer items-center gap-2.5 rounded-[5px] border-b border-nt-grey-light p-2.5 last:border-b-0 hover:bg-nt-grey-light ${isSelected ? 'bg-nt-grey-light' : ''}`}>
                    {chat.support === true ? (
                        <span className={`h-[50px] w-[50px] shrink-0 flex items-center justify-center rounded-full ${isSelected ? 'bg-white' : 'bg-nt-grey-light'} text-nt-blue`}>
                            <FiHeadphones size={28} />
                        </span>
                    ) : (
                    <img className={`h-[50px] w-[50px] shrink-0 rounded-full border-2 object-cover ${isSelected ? 'border-white' : 'border-nt-grey-light group-hover:border-white'}`} src={getImage(chat.user?.avatar, "AVATAR")} alt="" />
                    )}

                    <div className="min-w-0 flex-1 text-sm">
                        <div className="capitalize">
                            {chat.support === true && !chat.user?.firstName ? 'Support' : `${chat.user?.firstName ?? ''} ${chat.user?.lastName ?? ''}`.trim()}
                        </div>
                        {chat.message ? <div className={`truncate font-light ${deletedLast ? 'italic text-gray-500 line-through' : ''}`} title={chat.message.isFile && !chat.message.hidden ? chatListFileLabel(chat.message) : preview || undefined}>
                            {preview}
                        </div> : ''}
                    </div>
                    {n > 0 ? (
                        <span className="absolute right-2.5 top-1/2 flex h-[1.35rem] min-w-[1.35rem] -translate-y-1/2 items-center justify-center rounded-full bg-nt-blue px-1.5 text-[11px] font-bold leading-none text-white" aria-label={`${n} unread`}>
                            {n > 99 ? '99+' : n}
                        </span>
                    ) : null}
                </div>
            );
    }

    const chatsList = chats.filter(
        (v) =>
            (!v.user && "Support".includes(searchText) && v.support) ||
            (v.user && (v.user.firstName + " " + v.user.lastName).includes(searchText))

    )

    return (
        <>
            {search && <Search handleChangeSearchText={handleChangeSearchText} searchText={searchText} key={"search-input"}/>}
            <div className="flex w-full flex-col gap-2.5 rounded-xl bg-white">
                {
                    chatsList.length > 0 ?
                        (chatsList.map((chat, i) => {
                            return <MessagesItem chat={chat} key={chat._id ?? i} />
                        })) :
                        <NotFoundWidget message="No Chat History" />
                }
            </div>
        </>
    )
}

export { Messages }
